<template>
    <page-loading v-if="loading"></page-loading>
    <vx-page-layout v-else :layout="props.promotionId ? 'sidebar' : 'create'">
        <template v-if="props.promotionId" v-slot:subtitle>
            <a href="/settings/integrations/promotions" class="no-underline! text-sky-600! text-base font-normal">
                <font-awesome-icon widthAuto class="mr-1" :icon="faArrowLeft"></font-awesome-icon>
                All Promotions
            </a>
        </template>

        <template v-slot:title>
            <span v-if="!props.promotionId" class="inline-flex items-center gap-3">
                <font-awesome-icon widthAuto :icon="faBadgePercent" class="text-base"></font-awesome-icon>
                <span>New Promotion</span>
            </span>
            <slot v-else name="header">{{ promotion.name }}</slot>
        </template>

        <template v-if="!props.promotionId" v-slot:description>Create a new promotion.</template>

        <template v-if="props.promotionId" v-slot:sidebar>
            <page-sidebar
                :links="[
                    {
                        href: `/settings/integrations/promotions/${props.promotionId}`,
                        label: 'Details',
                    },
                    {
                        href: `/settings/integrations/promotions/${props.promotionId}/coupons`,
                        label: 'Coupon Codes',
                    },
                    {
                        href: `/settings/integrations/promotions/${props.promotionId}/coupons/imports`,
                        label: 'Imports',
                    },
                ]"
            ></page-sidebar>
        </template>

        <slot></slot>
    </vx-page-layout>
</template>

<script setup>
import { VxPageLayout } from '@voxie/frontend-components';
import PageLoading from '~/components/general/PageLoading.vue';
import { faArrowLeft, faBadgePercent } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import PageSidebar from '~/components/general/PageSidebar.vue';
import { usePromotionDetails } from '~/components/promotions/usePromotionDetails';
import { onMounted, provide } from 'vue';
import { PAGE_HEADING_LEVEL } from '~/provides/pageHeadingLevel';

const props = defineProps({
    promotionId: {
        type: Number,
        required: false,
    },
});

provide(PAGE_HEADING_LEVEL, 'h2');

const { promotion, loading, mount } = usePromotionDetails();

onMounted(() => {
    mount(props.promotionId);
});
</script>
